function pictureTagFallback(event) {
    const source_elem = event.target.parentNode.getElementsByTagName("source")[0];
    if (source_elem) {
        source_elem.remove();
        console.log("removed element", event.target.src);
    } else {
        event.target.removeEventListener("error", pictureTagFallback);
        event.target.onerror = null;
        event.target.src = "https://cdn.labx.com/v2/images/articles/newsNoImage.png";
    }
}

window.pictureTagFallback = pictureTagFallback;